<template>
	<main class="app-main">
		<section class="content-section">
			<div class="content-wrap">
				<h1 class="verification-title">{{ $t('general.email_verification_in_progress') }}</h1>
			</div>
		</section>
	</main>
</template>

<script>
export default {
	name: "EmailVerification",
	data() {
		return {
			hash: null,
			userId: null,
			expires: null,
			signature: null,
		}
	},
	mounted() {
		let url = `/api/verify-email/${this.userId}/${this.hash}?expires=${this.expires}&signature=${this.signature}`;
		this.axios.get(url).then((response) => {
			this.$store.dispatch('processLogin', response);
		}).catch((error) => {
			if (error?.response?.data?.message){
				this.$swal.fire({
					icon: 'error',
					title: 'Oops',
					text: error.response.data.message
				});

				this.$router.push(this.$t('routes.landing.path'));
				return;
			}

			this.$swal.fire({
				icon: 'error',
				title: 'Oops',
				text: this.$t('general.default_error')
			});

			this.$router.push(this.$t('routes.landing.path'));
		});
	},
	created() {
		this.hash = this.$route.params.hash;
		this.userId = this.$route.params.userId;

		if (!this.$route.query.expires || !this.$route.query.signature) {
			return this.$router.push('/');
		}

		this.expires = this.$route.query.expires;
		this.signature = this.$route.query.signature;
	}
}
</script>

<style scoped lang="scss">
.native {
	.verification-title {
		color: var(--white-color, $whiteColor);
	}
}
.app-main {
	align-items: center;
	display: flex;
	justify-content: center;
}
.content-section {
	display: flex;
	align-items: center;
}
	.verification-title {
		color: var(--background-color, $backgroundColor);
		text-align: center;
		padding-bottom: 50px;
		font-size: 32px;
	}
</style>